import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../../../../components/icon/iconfont'
import { FormattedMessage } from 'react-intl'

export default props => {
    useStyles(classes)
    const {onPaymethod} = props

    return <div className={`${classes.DisableButton}`}>
        <button className={classes.Button} disabled>
            <span className={classes.PayNowText}>
                <FormattedMessage id="pay_now" defaultMessage="Pay Now"/>
            </span>
        </button>
        <button className={classes.Select} disabled>
            <Iconfont className={classes.Icon}>&#xe727;</Iconfont>
        </button>
    </div>
}